exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".eventos[data-v-1079fc42]{min-height:300px}.box-center[data-v-1079fc42]{margin:20px auto}.spinner[data-v-1079fc42]:after{background:#ff0002!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1079fc42","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/widgets/eventos.vue
// module id = luxV
// module chunks = 0